import React from 'react'

import HowToDialog from 'components/HowToDialog'
import T from 'components/FormattedMessage'
import Button from 'components/Button'

import autosubSymbolUrl from './assets/autosub_symbol.svg'

interface Props {
  open: boolean
  onClose: () => void
  onStoreClick: () => void
}

const AutoSubIntro: React.SFC<Props> = ({ open, onClose, onStoreClick }) => (
  <HowToDialog
    displayNew
    open={open}
    variant="dark"
    onClose={onClose}
    icon={<img alt="" src={autosubSymbolUrl} />}
    headline={<T id="autosub_intro_title" />}
    message={<T id="autosub_intro_description" />}
    actionLabel={<T id="autosub_intro_back" />}
    bottomChild={(
      <Button
        fullWidth
        rounded={false}
        size="large"
        color="primary"
        onClick={onStoreClick}
      >
        <T id="autosub_intro_store" />
      </Button>
    )}
  />
)

export default AutoSubIntro
